module.exports = __webpack_public_path__ + "img/logo-white.3c4a7b5.png";